/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Time_Display_AbsoluteInputs */

const fr_settings_time_display_absolute = /** @type {(inputs: Settings_Time_Display_AbsoluteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure absolue`)
};

const en_settings_time_display_absolute = /** @type {(inputs: Settings_Time_Display_AbsoluteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolute time`)
};

/**
* | output |
* | --- |
* | "Absolute time" |
*
* @param {Settings_Time_Display_AbsoluteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_time_display_absolute = /** @type {((inputs?: Settings_Time_Display_AbsoluteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Time_Display_AbsoluteInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_time_display_absolute(inputs)
	return en_settings_time_display_absolute(inputs)
});